import { Box, Typography, Link, List, ListItem, styled } from '@mui/material';
import Logo from '../../../Assets/BugLogo.png';

const StyledList = styled(List)(({ theme }) => ({
  listStyleType: 'disc',
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: 'list-item',
  marginLeft: theme.spacing(4),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
}));

const PrivacyPolicy = () => {
  const email = 'support@sportssouth.biz';

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3, md: 4 },
        maxWidth: '850px',
        margin: 'auto',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: 1.6,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mx: { xs: '20px', md: '40px' },
          mb: 1,
        }}
      >
        <img src={Logo} alt='Logo' style={{ maxWidth: '300px', height: 'auto' }} />
      </Box>
      <Typography variant='h4' sx={{ py: 3, fontWeight: 'bold' }}>
        Privacy Policy
      </Typography>
      <Typography variant='body1' sx={{ pb: 3, fontWeight: 'bold' }}>
        Effective Date: November 18, 2024
      </Typography>

      {/* 1. Introduction */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        1. <span style={{ fontStyle: 'italic' }}>Introduction.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 2 }}>
        This Privacy Policy outlines the practices and policies of Sports South, LLC ( "we," "us,"
        or "our") regarding the collection, use, and protection of personal information provided by
        users ( "you" or "your") of our website www.SportsSouth.app.
      </Typography>

      {/* 2. Collection of Personal Information */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        2. <span style={{ fontStyle: 'italic' }}>Collection of Personal Information.</span>
      </Typography>
      <Typography variant='body1'>We collect personal information from users when:</Typography>
      <StyledList>
        <StyledListItem>
          <Typography variant='body1'>
            You voluntarily provide it to us when using our website or services.
          </Typography>
        </StyledListItem>
        <StyledListItem>
          <Typography variant='body1'>
            You submit your phone number to receive messages via 10DLC.
          </Typography>
        </StyledListItem>
      </StyledList>

      {/* 3. Use of Personal Information */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        3. <span style={{ fontStyle: 'italic' }}>Use of Personal Information.</span>
      </Typography>
      <Typography variant='body1'>
        We use the personal information you provide for the following purposes:
      </Typography>
      <StyledList>
        <StyledListItem>
          <Typography variant='body1'>To provide the requested services.</Typography>
        </StyledListItem>
        <StyledListItem>
          <Typography variant='body1'>
            To send you messages via 10DLC as per your request.
          </Typography>
        </StyledListItem>
        <StyledListItem>
          <Typography variant='body1'>To comply with legal obligations.</Typography>
        </StyledListItem>
        <StyledListItem>
          <Typography variant='body1'>To improve our services and user experience.</Typography>
        </StyledListItem>
      </StyledList>

      {/* 4. Privacy and 10DLC */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        4. <span style={{ fontStyle: 'italic' }}>Privacy and 10DLC.</span>
      </Typography>
      <Typography variant='body1'>
        As a 10DLC service provider, we adhere to the following principles:
      </Typography>
      <StyledList>
        <StyledListItem>
          <Typography variant='body1'>
            Privacy policies and terms and conditions are displayed next to the phone number entry
            fields.
          </Typography>
        </StyledListItem>
        <StyledListItem>
          <Typography variant='body1'>
            Privacy policies explicitly state that end user information is protected and not shared
            or sold to third parties for marketing, lead generation, or analytics purposes.
          </Typography>
        </StyledListItem>
        <StyledListItem>
          <Typography variant='body1'>
            The opt-in and opt-out procedures for 10DLC traffic are clearly outlined in both the
            call-to-action (CTA) and the Terms and Conditions. Opt-in and opt-out occur via the
            10DLC number, and short code opt-out routes are not used.
          </Typography>
        </StyledListItem>
      </StyledList>

      {/* 5. Opting Out */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        5. <span style={{ fontStyle: 'italic' }}>Opting Out.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 2 }}>
        You can opt out of receiving messages by texting <b>STOP</b> to the 10DLC number associated
        with our service. If you need assistance or have questions, text <b>HELP</b> for help.
      </Typography>

      {/* 6. Disclosure of Personal Information */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        6. <span style={{ fontStyle: 'italic' }}>Disclosure of Personal Information.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 2 }}>
        We do not share or sell end-user information to third parties or affiliates for any
        marketing, lead generation, or analytics purposes.
      </Typography>

      {/* 7. Security */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        7. <span style={{ fontStyle: 'italic' }}>Security.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 2 }}>
        We take reasonable measures to protect your personal information from unauthorized access or
        disclosure.
      </Typography>

      {/* 8. Cookies and Tracking Technologies */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        8. <span style={{ fontStyle: 'italic' }}>Cookies and Tracking Technologies.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 2 }}>
        At Sports South, LLC we use cookies and similar tracking technologies on our website
        www.SportsSouth.app to enhance your browser experience and provide you with relevant
        information. Cookies are small text files that are placed on your device when you visit our
        site. These cookies serve various purposes, such as remembering your preferences, analyzing
        website traffic, and enabling us to offer you personalized content and advertisements.
      </Typography>
      <Typography variant='body1' sx={{ pb: 2, textIndent: '2em' }}>
        We use both essential cookies, which are necessary for the basic functionality of the site,
        and analytical cookies, which help us gather insights into how our website is used and make
        improvements accordingly. Essential cookies enable you to navigate our website and access
        its features securely, while analytical cookies allow us to understand which pages are most
        popular, which products or services you are interested in, and how you interact with our
        content.
      </Typography>
      <Typography variant='body1' sx={{ pb: 2, textIndent: '2em' }}>
        By using our website, you consent to the placement of cookies on your device. You can manage
        your cookie preferences through your browser settings, including blocking or deleting
        cookies, if you wish to restrict the data we collect. Please note that disabling certain
        cookies may impact your ability to fully utilize our website's features. For more
        information about how we handle your personal data and how to exercise your rights, please
        refer to our Privacy Policy. We periodically review and update our cookies policy to ensure
        it reflects our current practices and complies with relevant laws and regulations. Any
        updates will be posted on this page, so please check back periodically for the latest
        information. If you have any questions or concerns about our cookies policy, please contact
        us at <Link href={`mailto:${email}`}>{email}</Link>.
      </Typography>

      {/* 9. Third-Party Links */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        9. <span style={{ fontStyle: 'italic' }}>Third-Party Links.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 2 }}>
        Our website may contain links to third-party websites. We are not responsible for the
        privacy practices or content of these websites.
      </Typography>

      {/* 10. Changes to this Privacy Policy */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        10. <span style={{ fontStyle: 'italic' }}>Changes to this Privacy Policy.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 2 }}>
        We may update this Privacy Policy from time to time. The revised policy will be posted on
        our website with the effective date.
      </Typography>

      {/* 11. Contact Us */}
      <Typography variant='h6' sx={{ pb: 2, pt: 2, fontWeight: 'bold' }}>
        11. <span style={{ fontStyle: 'italic' }}>Contact Us.</span>
      </Typography>
      <Typography variant='body1' sx={{ pb: 3 }}>
        If you have any questions or concerns about this Privacy Policy or your personal
        information, please get in touch with us at <Link href={`mailto:${email}`}>{email}</Link>.
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
